import { AbilityBuilder, PureAbility } from '@casl/ability'

/* --------------------------
 * Types definitions
 * ------------------------*/
export type Actions = 'get' | 'create' | 'update' | 'delete'
export type Screens = 'home' | 'devices' | 'store' | 'stock' | 'sites' | 'spareparts' | 'profile' | 'statistics'

export type AppAbility = PureAbility<[Actions, Screens]>

/* --------------------------
 * Roles definitions
 * ------------------------*/
function User(): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(PureAbility)

  can('get', 'home')
  can('get', 'devices')
  can('get', 'store')
  can('get', 'stock')
  can('get', 'sites')
  can('get', 'spareparts')
  can('get', 'profile')
  can('get', 'statistics')

  return build()
}

/* --------------------------
 * Export definitions
 * ------------------------*/
export const ABILITIES = {
  DEFAULT: User(),
  User: User(),
  Administrator: User(),
}
